'use client';

import Link from 'next/link';

import Button from '@/components/ui/Button/Button';

import { ArrowRight } from 'lucide-react';

export function LandingCTA() {
  return (
    <section className='bg-background px-6 py-20 sm:py-28 md:px-8'>
      <div className='mx-auto max-w-4xl'>
        <div
          className='relative overflow-hidden rounded-3xl border border-transparent p-10 text-center sm:p-16 md:p-20'
          style={{
            backgroundColor: '#066653',
            backgroundImage:
              "url('data:image/svg+xml,%3Csvg width=\\'60\\' height=\\'60\\' viewBox=\\'0 0 60 60\\' xmlns=\\'http://www.w3.org/2000/svg\\'%3E%3Cg fill=\\'none\\' fill-rule=\\'evenodd\\'%3E%3Cg fill=\\'%23ffffff\\' fill-opacity=\\'0.05\\'%3E%3Cpath d=\\'M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z\\'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E')"
          }}>
          <div className='relative z-10'>
            <h2 className='mb-6 text-3xl leading-tight font-black tracking-tight text-white sm:text-4xl lg:text-5xl'>
              Ready to Transform Your <br className='hidden sm:block' />
              <span style={{ color: '#a3f7bf' }}>Bioeconomy Strategy?</span>
            </h2>

            <p className='mx-auto mb-10 max-w-2xl text-base leading-relaxed text-white/85 sm:text-lg'>
              Get data-driven bioeconomy insights delivered to your inbox every
              week.
            </p>

            <div className='flex flex-col items-center justify-center gap-4 sm:flex-row'>
              <Link href='/auth/signup'>
                <Button
                  variant='primary'
                  className='!px-8 !py-4 !text-[13px]'>
                  Start for Free
                  <ArrowRight className='ml-2 inline-block size-4' />
                </Button>
              </Link>

              <Link href='/contact'>
                <Button
                  variant='outline'
                  className='!border-border bg-transparent !px-8 !py-4 !text-[13px] !text-white hover:!bg-white/10 hover:!text-white'>
                  Schedule Demo
                </Button>
              </Link>
            </div>

            <p className='mt-8 text-[12px] font-semibold tracking-wide text-white/60 uppercase'>
              No credit card required • Premium support included
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
